export default "__VITE_ASSET__a86e12dc__"